
import Vue from "vue";
import { BATTERY_ROLLUP_COLUMNS } from "@/common/constants/batteryStatus";

const STORAGE_KEY = "om.batteryPanel.expanded";

export default Vue.extend({
  name: "BatteryByCompanyPanel",
  props: {
    rows: { type: Array, default: () => [] },
    totals: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
    activeCompanyId: { type: Number, default: null },
    activeStatusKey: { type: String, default: null },
  },
  data() {
    return {
      columns: BATTERY_ROLLUP_COLUMNS,
      panelOpen: 0 as number | undefined,
    };
  },
  created() {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      // Default expanded (0) unless the user explicitly collapsed it before.
      this.panelOpen = stored === "closed" ? undefined : 0;
    } catch {
      this.panelOpen = 0;
    }
  },
  methods: {
    onSelect(row: any, col: any) {
      this.$emit("select", { companyId: row.company_id, companyName: row.company, statusKey: col.key });
    },
    // Light tinted pill background behind the dot + count -- appends ~10% alpha
    // to the status hex color (e.g. "#8B0000" -> "#8B00001A").
    pillBg(color: string): string {
      return `${color}1A`;
    },
  },
  watch: {
    panelOpen(value: number | undefined) {
      try {
        window.localStorage.setItem(STORAGE_KEY, value === undefined ? "closed" : "open");
      } catch {
        /* localStorage unavailable -- ignore */
      }
    },
  },
});
